import fetch from "auth/FetchInterceptor";

const OrdersService = {};

OrdersService.fetch = function (data) {
  return fetch({
    url: `/orders?start_date=${data.startDate}&end_date=${data.endDate}&agency=${data.agency}`,
    method: "get",
  });
};

OrdersService.create = function (data) {
  return fetch({
    url: "/orders",
    method: "post",
    data,
  });
};

OrdersService.update = function (data) {
  return fetch({
    url: "/orders/" + data.Uuid,
    method: "put",
    data,
  });
};

OrdersService.delete = function (id) {
  return fetch({
    url: "/orders/" + id,
    method: "delete",
  });
};

export default OrdersService;
